import { IMatchData, IMatchesByDay } from '../../lib/model'

const statusCodes = {
  Slutt: [1, 16, 17],
  Avlyst: [4, 5],
  Plannlagt: [2, 3, 6],
  Pågår: [7, 8, 9, 10, 11, 12, 13, 14, 15, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
}

export function statusLabel(statusCode: number) {
  for (let statusCodesKey in statusCodes) {
    if (statusCodes[statusCodesKey].includes(statusCode)) {
      return statusCodesKey
    }
  }
  return 'Plannlagt'
}

const MONTHS = [
  'jan.',
  'feb.',
  'mars',
  'april',
  'mai',
  'juni',
  'juli',
  'aug.',
  'sept.',
  'okt.',
  'nov.',
  'des.',
]

export function formatMatchDate(matchDate) {
  if (!matchDate) {
    return matchDate
  }
  const date = new Date(matchDate)
  return `${date.getDate()}. ${MONTHS[date.getMonth()]}`
}

export function findNearestTournamentDay(matches: IMatchesByDay): Date {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const matchDates = Object.keys(matches)
    .map((a) => {
      return new Date(a)
    })
    .filter((a) => a >= today)

  matchDates?.sort(function (a, b) {
    var distancea = Math.abs(today.getTime() - a.getTime())
    var distanceb = Math.abs(today.getTime() - b.getTime())
    return distancea - distanceb // sort a before b when the distance is smaller
  })
  return matchDates[0]
}

export const isNearestTournamentDay = (matchDateStr, nearestTournamentDay) => {
  const matchDate = new Date(matchDateStr)
  return (
    matchDate.getDate() === nearestTournamentDay.getDate() &&
    matchDate.getMonth() === nearestTournamentDay.getMonth() &&
    matchDate.getFullYear() === nearestTournamentDay.getFullYear()
  )
}

export function sortMatches(dayMatches: IMatchData[]): IMatchData[] {
  return dayMatches?.sort((a, b) => {
    const dateA = new Date(a.timestamp)
    const dateB = new Date(b.timestamp)
    return dateA.getTime() - dateB.getTime()
  })
}

export function findNearestGameIndex(dayMatches: IMatchData[]): number {
  const ongoingIndex = dayMatches.findIndex(
    (matchData) => statusLabel(matchData.matchStatusId) === 'Pågår'
  )

  if (ongoingIndex >= 0) {
    return ongoingIndex
  }

  const plannedIndex = dayMatches.findIndex(
    (matchData) => statusLabel(matchData.matchStatusId) === 'Plannlagt'
  )

  if (plannedIndex >= 0) {
    return plannedIndex
  }

  return 0
}
